var _rect, _path, _path2, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.2,
    height: 44.2,
    x: 5.9,
    y: 5.9,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 2.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.25 20.125c1.295-2.064 3.448-3.442 5.908-3.802a2.794 2.794 0 0 1-.222-1.08c0-1.614 1.375-2.993 3.064-2.993 1.69 0 3.064 1.379 3.064 2.994 0 .381-.082.744-.222 1.079 2.46.36 4.613 1.738 5.908 3.802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.364 40.248c-5.207-5.235-10.436-13.557-2.17-20.122l17.61-.001c8.28 6.555 3.025 14.934-2.189 20.125"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 6.125,
    x: 22.75,
    y: 26.25,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 3.25,
    x: 18.5,
    y: 40.375,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1.625
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiche);
export default __webpack_public_path__ + "static/media/niche.c5e020050ff1a2ac0f44df73e55ded94.svg";
export { ForwardRef as ReactComponent };